var C = Object.defineProperty, b = Object.defineProperties;
var x = Object.getOwnPropertyDescriptors;
var i = Object.getOwnPropertySymbols;
var h = Object.prototype.hasOwnProperty, o = Object.prototype.propertyIsEnumerable;
var c = (l, a, e) => a in l ? C(l, a, { enumerable: !0, configurable: !0, writable: !0, value: e }) : l[a] = e, n = (l, a) => {
  for (var e in a || (a = {}))
    h.call(a, e) && c(l, e, a[e]);
  if (i)
    for (var e of i(a))
      o.call(a, e) && c(l, e, a[e]);
  return l;
}, u = (l, a) => b(l, x(a));
var g = (l, a) => {
  var e = {};
  for (var t in l)
    h.call(l, t) && a.indexOf(t) < 0 && (e[t] = l[t]);
  if (l != null && i)
    for (var t of i(l))
      a.indexOf(t) < 0 && o.call(l, t) && (e[t] = l[t]);
  return e;
};
import { jsx as r } from "react/jsx-runtime";
import y, { createElement as D } from "react";
import { components as m } from "react-select";
const f = (t) => {
  var d = t, {
    children: l,
    selectProps: a
  } = d, e = g(d, [
    "children",
    "selectProps"
  ]);
  const s = {
    cx: e.cx,
    clearValue: e.clearValue,
    getStyles: e.getStyles,
    getValue: e.getValue,
    getClassNames: e.getClassNames,
    hasValue: e.hasValue,
    isMulti: e.isMulti,
    isRtl: e.isRtl,
    options: e.options,
    selectOption: e.selectOption,
    setValue: e.setValue,
    selectProps: a,
    theme: e.theme,
    innerProps: e.innerProps
  };
  return /* @__PURE__ */ r(m.ValueContainer, u(n({}, e), { selectProps: a, children: y.Children.map(l, (V) => V || (e.hasValue ? /* @__PURE__ */ r(m.SingleValue, u(n({}, s), { data: e.getValue(), isDisabled: a.isDisabled, children: a.placeholder })) : /* @__PURE__ */ D(m.Placeholder, u(n({}, s), { key: "placeholder", isFocused: a.isFocused, isDisabled: a.isDisabled }), a.placeholder))) }));
};
f.displayName = "ValueContainer";
export {
  f as ValueContainer
};
//# sourceMappingURL=ValueContainer.es.js.map
